import React from 'react';
import { Outlet, Link, Navigate, useLocation } from 'react-router-dom';  // Import Outlet and Link from react-router-dom

import TeammemberHeader from '../components/TeammemberHeader';
import TeammemberSidebar from '../components/TeammemberSidebar';
import DashboardFooter from '../components/DashboardFooter';
import { Provider } from 'react-redux';
import store from '../../src/redux/store';
import { ToastContainer } from "react-toastify";
import SignageTeammemberHeader from 'components/SignageTeammemberHeader';
import SignageTeammemberSidebar from 'components/SignageTeammemberSidebar';
import { getAuthCookie, unauthenticatedLoginPath } from '../utils/authCookies';
// import "react-toastify/dist/ReactToastify.css";

interface LayoutProps {
    children?: React.ReactNode;  // Make children optional as we are using Outlet
}

const SignageTeammemberLayout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  if (!getAuthCookie("sessionToken")) {
    return <Navigate to={unauthenticatedLoginPath(location.pathname, location.search)} replace />;
  }

  return (
    <Provider store={store}>
    <div id="layout-wrapper">
      {/* Header component */}
      <SignageTeammemberHeader />
      
      {/* Sidebar component */}
      <SignageTeammemberSidebar />

      {/* Main content area */}
      <div className="main-content me-0">
        <div className="page-content">
          <div className="container-fluid">
           
            {/* Render children or Outlet (child routes) */}
            {children ? children : <Outlet />}  {/* Render children if passed, else Outlet */}
          </div>
        </div>

        {/* Footer component */}
        <DashboardFooter />
      </div>
    </div>
    </Provider>
  );
};

export default SignageTeammemberLayout;
